module.exports = __webpack_public_path__ + "img/amanetnovo.867fe67b.png";